exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-check-label-login[data-v-9fa9fb78]{\n    margin-bottom: 0;\n    white-space: nowrap;\n}\n.btn-primary[data-v-9fa9fb78]:hover {\n    color: #fff !important;\n    background-color: #350f71 !important;\n    border-color: #300e66 !important;\n}\n", ""]);

// exports
